/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import classNames from 'classnames';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import AbsoluteDropdownContainer from 'ui-library/AbsoluteDropdownContainer';
import LegacyDropdownMenu from 'ui-library/dropdowns/LegacyDropdownMenu';
import ErrorMessage from 'ui-library/ErrorMessage';

export interface LegacySelectDropdownProps {
  className?: string;
  displayName: React.ReactNode;
  error?: string;
  menuClassName?: string;
  items: Array<Array<any>>;
  disabled?: boolean;
  dataTestAttrs?: DataTestAttrs;
  disableEventPropagation?: boolean;
}

type LegacySelectDropdownState = any;

/**
 * Select-style dropdown with a default selection.
 *
 * The outside world is responsible for updating the display name to match the current selection.
 *
 * @deprecated - Use ui-library/dropdowns/SelectDropdown.tsx instead.
 */
class LegacySelectDropdown extends React.Component<LegacySelectDropdownProps, LegacySelectDropdownState> {
  static UnselectedOption: any;

  state: LegacySelectDropdownState = {isOpen: false};

  _toggleDropdown = (): void => {
    this.setState({isOpen: !this.state.isOpen});
  };

  _handleClose = (): void => {
    this.setState({isOpen: false});
  };

  render(): JSX.Element {
    return (
      <div className="selectDropdown" {...getTestProps(this.props.dataTestAttrs)}>
        <AbsoluteDropdownContainer
          menu={
            <LegacyDropdownMenu
              className={classNames('dropdown-menu--dropDown selectDropdown-menu', this.props.menuClassName)}
              items={this.props.items}
            />
          }
          onRequestClose={this._handleClose}
          open={this.state.isOpen}
          shouldCloseOnInsideClick={true}
        >
          <span className={classNames('dropdown', this.props.className, {open: this.state.isOpen})}>
            <button
              className={classNames('btn-af-default dropdown-toggle', 'selectDropdown-button', {
                'fieldInput-input--error': this.props.error != null,
              })}
              disabled={this.props.disabled}
              onClick={(event) => {
                this._toggleDropdown();
                if (this.props.disableEventPropagation) {
                  event.stopPropagation();
                }
              }}
              type="button"
            >
              <span className="u-lr-split">
                <span className="selectDropdown-text">{this.props.displayName}</span>
                <span className="caret" />
              </span>
            </button>
          </span>
        </AbsoluteDropdownContainer>
        {this.props.error && <ErrorMessage error={this.props.error} />}
      </div>
    );
  }
}

interface UnselectedOptionProps {
  children: React.ReactNode;
}

function UnselectedOption({children}: UnselectedOptionProps): JSX.Element {
  return <span className="u-faded">{children}</span>;
}
LegacySelectDropdown.UnselectedOption = UnselectedOption;

Object.freeze(LegacySelectDropdown);
export default LegacySelectDropdown;
